// src/components/Background.tsx
import { useEffect } from 'react';

const Background = () => {
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const parallaxElements = document.querySelectorAll('.parallax');
      
      parallaxElements.forEach(element => {
        const speed = element.getAttribute('data-speed');
        if (speed) {
          const yPos = scrollPosition * parseFloat(speed);
          element.setAttribute('style', `transform: translateY(${yPos}px)`);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[-1] pointer-events-none">
      <div className="relative h-full w-full overflow-hidden">
        <img 
          src="/images/a9e0e577-6502-425f-80a7-a09ea6ba38e7.png" 
          alt="Pixel art landscape background" 
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 parallax" data-speed="0.05">
          <div className="w-full h-full bg-forest/30 backdrop-blur-[2px]"></div>
        </div>
      </div>
    </div>
  );
};

export default Background;